//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LatestUploads from "@/components/LatestUploads/LatestUploads.vue";
import { EventBus } from "@/event-bus.js";
import { AddressbarColor } from "quasar";
import BackendServices from "@/services/backend-services.js";

export default {
  name: "LayoutDefault",

  components: {
    LatestUploads,
  },
  data() {
    return {
      drawerState: false,
      miniState: true,
      latestUploads: false,
      userInfo: {
        name: "",
        department: "",
      },
      rules: null,
      validationNotification: 0,
      needsRefreshBanner: false,
    };
  },
  methods: {
    // changeDrawerState() {
    //   this.drawerState = !this.drawerState;
    // },
    reloadWindow() {
      window.location.reload()
    },
    emitEventQuery() {
      EventBus.$emit("rightDrawerQueryAction");
    },
    hideLeftDrawer() {
      this.miniState = true;
    },

    returnHome() {
      this.$router.push("/");
    },
    testAction() { },
    logout() {
      this.$store.dispatch("logout");
    },
    getUserInfo() {
      let user = this.$store.getters.userInfo;
      this.userInfo.name = user.userName;
      this.userInfo.department = user.department;
      // this.versionData = JSON.parse(this.$store.getters.versionInfo)
    },

    getInitials() {
      let initials = "";
      let words = this.userInfo.name.split(" ");
      words.forEach((word) => {
        initials += word.charAt(0);
      });
      return initials;
    },
    getPendingValidationsNotifications() {
      BackendServices.getPendingValidationsNotification().then((response) => {
        this.validationNotification = response.data["pending_count"];
      });
    },
    getRuleSettings() {
      this.rules = {
        system_settings: this.can("system_settings"),
        admin_general: this.can("admin_general"),
        preview_version: this.can("preview_version"),
        data_settings: this.can("data_settings"),
        client_data_settings: this.can("client_data_settings"),
        client_uploads: this.can("client_uploads"),
        general: this.can("general"),
        self_settings: this.can("self_settings")
      };
    },
  },
  computed: {
    sidekiqUrl() {
      return process.env.VUE_APP_BACKEND_HOST + "/sidekiq";
    },
    didAutoLogout() {
      return this.$store.getters.didAutoLogout;
    },
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
  },
  beforeCreate() {
    this.$store.dispatch("tryLogin");
  },
  created() {
    AddressbarColor.set("#2D5270");
    if (localStorage.getItem("token_create_date") != null) {
      const currentTime = new Date().getTime();
      if (currentTime - localStorage.getItem("token_create_date") > 86400000) {
        this.$store.dispatch("autoLogout");
      }
    }

  },
  mounted() {
    this.getUserInfo();
  },
  beforeMount() {
    this.getRuleSettings();
    if (this.isLoggedIn) {
      this.getPendingValidationsNotifications();
    }
  },
  watch: {
    "$store.getters.needsRefresh": function (value) {
      this.needsRefreshBanner = value;
    },
    "$store.getters.token": function (newVal) {
      if (newVal == null && this.$route.name != "accountActions") {
        this.$router.push("/login");
      }
    },
    didAutoLogout() {
      this.$router.push("/login");
    },
    isLoggedIn() {
      this.getUserInfo();
      this.getRuleSettings();
    },
  },
};
